import { type FC } from "react";
import RestaurantFilterBar from "./RestaurantFilterBar";
import RestaurantDateRangeDisplay from "./RestaurantDateRangeDisplay";
import type { RestaurantFilters } from "../utils/restaurantMetrics";

export interface RestaurantHeaderActionsProps {
  filters: RestaurantFilters;
  // eslint-disable-next-line no-unused-vars
  setFilter: <K extends keyof RestaurantFilters>(key: K, value: RestaurantFilters[K]) => void;
  isFiltered: boolean;
  onReset: () => void;
}

const RestaurantHeaderActions: FC<RestaurantHeaderActionsProps> = ({
  filters,
  setFilter,
  isFiltered,
  onReset,
}) => {
  return (
    <div className="restaurant-header-actions">
      <RestaurantDateRangeDisplay
        startDate={filters.startDate}
        endDate={filters.endDate}
        onRangeChange={range => {
          setFilter("startDate", range.startDate);
          setFilter("endDate", range.endDate);
        }}
      />
      <RestaurantFilterBar
        filters={filters}
        setFilter={setFilter}
        isFiltered={isFiltered}
        onReset={onReset}
      />
    </div>
  );
};

export default RestaurantHeaderActions;
